<template>
 <div>
    <vue-headful :title="'JSAs :: MeritEHS'"/>

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item active"><i class="fa fa-files-o"></i> Jobsite Safety Analyses</li>
            <li class="ml-3">
                <router-link :to="`/jsa/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create JSA</router-link>
            </li>
        </ol>
    </h4>

    <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4" v-if="canManage">
        <b-nav-item :active="curTab === 'list'" @click="curTab = 'list'">
            JSAs
        </b-nav-item>
        <b-nav-item :active="curTab === 'settings'" @click="curTab = 'settings'">
            Hazard &amp; Control Settings
        </b-nav-item>
        <b-nav-item :active="curTab === 'reminders'" @click="curTab = 'reminders'">
            Reminders <span v-if="reminder_count">({{ reminder_count }})</span>
        </b-nav-item>
    </ul>

    <saved-filter-title :filterKey="'jsaFilters'" />

    <div class="card" v-show="curTab == 'list'">
        <div class="card-body">
           <jsa-list :allowFilterSaving="true" />
        </div>
    </div>
    <template v-if="canManage">
        <div class="card" v-show="curTab == 'settings'">
            <div class="card-body">
                <safety-settings-list />
            </div>
        </div>
        <div class="card" v-show="curTab == 'reminders'">
            <div class="card-body">
                <v-server-table ref="jsaReminderList" url="/jsa/reminders/list" :columns="jsaReminderCols" :options="jsaReminderOpts">

                    <div slot="afterFilterWrapper" class="ml-2 ml-sm-0 mt-2 mt-sm-0">
                        <router-link class="btn btn-outline-success" :to="`/jsa/reminders/create`">
                            <i class="fa fa-plus"></i> Add Reminder
                        </router-link>
                    </div>

                    <router-link slot="id" slot-scope="props" :to="`/jsa/reminders/edit/${props.row.id}`" title="Edit JSA Reminder" class="btn btn-sm btn-default">
                        <i class="fa fa-edit"></i>
                    </router-link>

                    <router-link slot="reminder_name" slot-scope="props" :to="`/jsa/reminders/edit/${props.row.id}`" title="View JSA Reminder">
                        {{ props.row.reminder_name }}
                    </router-link>

                    <template slot="jsa_name" slot-scope="props">
                        <router-link :to="`jsa/templates/view/${props.row.asset_id}`" v-if="props.row.jsa_name">{{ props.row.jsa_name }}</router-link>
                        <span v-else>-- Check for any JSA Template --</span>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label :class="`badge badge-${props.row.is_active == 1 ? 'success' : 'warning'}`">
                            {{ props.row.is_active == 1 ? 'Active' : 'Inactive' }}
                        </label>
                    </template>

                    <template slot="child_row" slot-scope="props">

                        <div style="margin-bottom: 8px;">
                            <label class="text-muted">Description:</label><br/>
                            {{ props.row.reminder_description }}
                        </div>

                        <div style="margin-bottom: 8px;">
                            <label class="text-muted">Additional CC Emails:</label><br/>
                            <ul v-if="props.row.reminder_config && props.row.reminder_config.additional_emails">
                                <li v-for="email in props.row.reminder_config.additional_emails">{{ email }}</li>
                            </ul>
                        </div>

                    </template>

                </v-server-table>
            </div>
        </div>
    </template>
</div>
</template>

<script>
    export default {
        data: function() {
            return {
                curTab: 'list',
                reminder_count: null,

                jsaReminderCols: ['id', 'reminder_name', 'jsa_name', 'shorthand', 'is_active'],
                jsaReminderOpts: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        reminder_name: 'Reminder Name',
                        jsa_name: 'JSA Template',
                        shorthand: 'Config',
                        is_active: 'Is Active'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'reminders.reminder_name',
                    },
                    uniqueKey: 'id',
                    responseAdapter: (response) => {
                        //Emit the count
                        this.reminder_count = response.data.count;

                        //Send it
                        return response.data;
                    },
                },
            }
        },

        computed: {

            canManage(){
                //Send it
                return this.$store.state.user.is_admin;
            },

        },

        methods: {

        },

        mounted(){
            //Send it
            if(this.canManage)
            {
                //Check for a hash
                if(window.location.hash)
                {
                    //Set the current tab
                    this.curTab = window.location.hash.replace('#', '');
                }
            }
        },
    }
</script>
